<template>
  <span
    v-member-hover-preview="getHoverMember"
    class="user-mention"
    :class="{ 'user-mention--me': isMe }"
  >
    <span>&nbsp;</span>{{ denotationChar }}{{ userLabel }}<span>&nbsp;</span>
  </span>
</template>
<script>
import getMemberLabel from '@/utilities/getMemberLabel';
import { isPublicPageApp } from '@/utilities/isPublicPageApp';

export default {
  props: {
    userId: {
      type: String,
      required: true,
      default: '',
    },
    denotationChar: {
      type: String,
      required: false,
      default: '@',
    },
    userValue: {
      type: String,
      required: false,
      default: '',
    },
    mentionTime: {
      type: String,
      required: false,
      default: Math.floor(new Date().getTime() / 1000),
    },
  },
  computed: {
    user() {
      return this.$store.getters.getMemberById(this.userId);
    },
    getHoverMember() {
      if (isPublicPageApp()) return {};
      if (this.isGuestRole && !Object.keys(this.user).length) {
        return { id: this.userId };
      }
      return this.user;
    },
    userLabel() {
      if (isPublicPageApp()) {
        return this.userValue;
      }
      const userOb = Object.keys(this.user).length;
      if (!userOb) {
        return this.isGuestRole ? this.translate('hiddenMember') : this.userValue;
      }
      return getMemberLabel(this.user);
    },
    isMe() {
      if (isPublicPageApp()) return false;
      const currentUserId = this.$store.getters.getUserId;
      return this.userId === currentUserId;
    },
  },
};
</script>

<style lang="scss">
.user-mention {
  color: $stLightBlack;
  border-radius: 4px;
  display: inline;
  white-space: nowrap;
  background-color: $gray100;
  outline: 1px;
  box-shadow: 0px 0px 0px 1px inset var(--dividers);
  @apply bg-important-bg text-text-default;

  &--me {
    background-color: $warning100;
    @apply bg-inline-selection text-text-default;
  }
}
</style>
